import { render, staticRenderFns } from "./TradesDistribution.vue?vue&type=template&id=1f557601&scoped=true"
import script from "./TradesDistribution.vue?vue&type=script&lang=js"
export * from "./TradesDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f557601",
  null
  
)

export default component.exports